import { IconButton } from '@openeducation/oe-rn-components';
import React from 'react';
import { StyleSheet } from 'react-native';

import { useColors } from '../../hooks';

interface CarouselArrowButtonProps {
  disabled: boolean;
  onPress: () => void;
}

export const CarouselLeftArrowButton = ({
  disabled,
  onPress,
}: CarouselArrowButtonProps) => {
  const colors = useColors();

  return (
    <IconButton
      disabled={disabled}
      name="chevron-left"
      color={colors.gray}
      size={24}
      onPress={onPress}
      style={[styles.arrowButton, styles.arrowLeft]}
    />
  );
};

export const CarouselRightArrowButton = ({
  disabled,
  onPress,
}: CarouselArrowButtonProps) => {
  const colors = useColors();

  return (
    <IconButton
      disabled={disabled}
      name="chevron-right"
      color={colors.gray}
      size={24}
      onPress={onPress}
      style={[styles.arrowButton, styles.arrowRight]}
    />
  );
};

const styles = StyleSheet.create({
  arrowButton: {
    position: 'absolute',
    top: '30%',
    zIndex: 5,
  },
  arrowLeft: {
    left: 70,
  },
  arrowRight: {
    right: 70,
  },
});
